let serverUrl = "/gzhapi";
// serverUrl = `http://${window.location.host}/gzhapi`;

let DevserverUrl = `http://${window.location.host}`;

const joint = (url) => {
  return serverUrl + url;
};
// const devjoint = (url) => {
//   return DevserverUrl + url;
// };
const allUrl = {
  register: {
    getLetterListData: joint("/complaint-manage/selectOnlineOrg"), //获取企业网上信
    getMatrix:joint("/complaint-manage/selectOrgLogo"), //获取企业微信矩阵
    Authentication:joint("/blade-auth/oauth/identityVerify"),// 个人身份认证
    getDocType: joint("/blade-system/dict-biz/dictionary"), // 获取证件类型
    getRegion: joint("/blade-system/region/lazy-tree"), // 获取省市区
    getImageCode: joint("/blade-auth/oauth/captcha"), //  获取图片验证码
    getPhoneCode: joint("/blade-auth/oauth/smsSend"), //  获取手机验证码
    getIsPhoneCode: joint("/blade-auth/oauth/smsSendLogin"), //  手机校验
    captchaImage: joint("/blade-auth/oauth/captchaCheck"), // 验证图片验证码
    userRegister: joint("/user-manage/userRegister"), // 用户注册
    userLogin: joint("/blade-auth/oauth/userToken"), // 用户登录
    userAllLogin: joint("/blade-auth/oauth/userAllToken"), // 新的用户登录
    passWordForget: joint("/user-manage/passWordForget"), // 身份验证
    uploadePaswed: joint("/user-manage/passWordForgetUpdate"), // 重置账户
    getUserInfo: joint("/user-manage/getUserInfo"), // 获取个人信息
    upladeInfo: joint("/user-manage/updateUserInfo"), // 个人信息修改
    sensitiveFilter: joint("/sensitive-manage/filter"), // 敏感词过滤
    editPhone: joint("/user-manage/updatePhoneNumber"), //修改绑定手机号码
    editPasswed: joint("/user-manage/loginForgetPassWord"), // 登录状态下修改密码
    goLogout: joint("/blade-auth/oauth/logout"), // 退出登录
    deleteUser: joint("/user-manage/deleteUser"), // 注销账号
    updateQuestion: joint("/user-manage/loginUpdateQuestion"), // 修改密保答案
    proposcal: joint("/recommendation-manage/save"), // 建议征集
    getPropList: joint("/recommendation-manage/list"), // 获取建议征集列表
    PropDetial: joint("/recommendation-manage/detail"), // 建议征集详情
    // 投诉请求：
    getRegnData: joint("/complaint-manage/getCity"), // 获取省市县数据
    getCategory: joint("/complaint-manage/getDic"), // 获取问题类别数据
    getSelectOrg: joint("/complaint-manage/selectOrg"), // 获取涉事单位
    saveData: joint("/complaint-manage/save"), // 数据提交保存
    getplaitData: joint("/complaint-manage/selectAll"), // 查询投诉列表
    getDetailedData: joint("/complaint-manage/selectOne"),
    uploadFilen: joint("/file-manage/download/file"),
    DuplicateDubmit: joint("/complaint-manage/ckeckSave"), // 当天是否重复提交
    DuplicateResBook: joint("/complaint-manage/ckeckResBook"), // 重复涉事单位是否有答复意见书
    getNationData: joint("/complaint-manage/getByDicflag"), // 获取国籍数据
    getCategoryData: joint("/complaint-manage/getCategoryByCode"), // 获取内容分类
  },
};

export default allUrl;
